import Component from "../components/Component";
import { newElement } from "../Dom";

export default class NotFoundView extends Component {

    connectedCallback(): void {
        this.replaceChildren(
            newElement("h1", { text: "404" }),
            newElement("p", { text: "Fann ikkje sida." }),
        );
    }
}

customElements.define("not-found-view", NotFoundView);
